<script setup lang="ts">
  import {Model} from "@/app/Model";
  import {CommsFamiglia} from "@/app/CommsFamiglia";

  let model: Model = Model.getReactiveInstance();
  let comms: CommsFamiglia = CommsFamiglia.getInstance();

  function handleSubmit(): void {
    if (model.fam_admin.itemFamiglia.id_localita == null || model.fam_admin.itemFamiglia.id_localita == "") {
      alert ("Località obbligatorio!")
      return;
    }
    if (model.fam_admin.itemFamiglia.oggetto_di_giudizio == null || model.fam_admin.itemFamiglia.oggetto_di_giudizio == "") {
      alert ("Oggetto di Giudizio obbligatorio!")
      return;
    }

    model.fam_admin.itemFamiglia.modifica_manuale = true;
    comms.famigliaAdmin.chiamataFamigliaSave(()=> {})
  }

  function addGiudice(): void {
    model.fam_admin.itemFamiglia.giudice?.push('');
  }

  function removeGiudice(index: number): void {
    model.fam_admin.itemFamiglia.giudice?.splice(index, 1);
  }

  function addRiferimentoNormativo(): void {
    model.fam_admin.itemFamiglia.riferimento_normativo?.push('');
  }

  function removeRiferimentoNormativo(index: number): void {
    model.fam_admin.itemFamiglia.riferimento_normativo?.splice(index, 1);
  }

  function addMotiviAddebitoSeparazione(): void {
    model.fam_admin.itemFamiglia.motivi_addebito_separazione?.push('');
  }

  function removeMotiviAddebitoSeparazione(index: number): void {
    model.fam_admin.itemFamiglia.motivi_addebito_separazione?.splice(index, 1);
  }
</script>


<template>
  <div class="modal fade" id="ModalAdminFamigliaItem" tabindex="-1" aria-labelledby="labelModalAdminFamigliaItem"
       aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-xl">
      <div class="modal-content">
          <div class="modal-header">
            <h1 class="modal-title fs-5" id="labelModalAdminFamigliaItem">
              Modifica {{ model.fam_admin.itemFamiglia.id_doc_master }}
            </h1>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="mb-3 not-visible">
              <label for="idDocMaster" class="form-label">ID Doc Master</label>
              <input type="number" class="form-control" id="idDocMaster" v-model.number="model.fam_admin.itemFamiglia.id_doc_master">
            </div>
            <div class="mb-3">
              <label for="iOggetto_di_giudizio" class="form-label">Oggetto del Giudizio</label>
              <select class="form-select" id="iOggetto_di_giudizio" v-model="model.fam_admin.itemFamiglia.oggetto_di_giudizio">
                <option value="">Scegli...</option>
                <option v-for="(item) in Model.lista_oggetto_di_giudizio" :value="item" :key="'ogg_'+item">{{ item }}</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="iTipologia_procedimento" class="form-label">Tipologia procedimento</label>
              <select class="form-select" id="iTipologia_procedimento" v-model="model.fam_admin.itemFamiglia.tipologia_procedimento">
                <option value="">Scegli...</option>
                <option v-for="(item) in Model.lista_tipologia_procedimento" :value="item" :key="'tip_'+item">{{ item }}</option>
              </select>
            </div>

            <div class="mb-3">
              <input type="checkbox" class="form-check-input" id="iAddebito" v-model="model.fam_admin.itemFamiglia.addebito">
              <label class="form-check-label" for="iAddebito"> &nbsp;Addebito</label>
            </div>

            <!-- Modifica, Aggiunta e Rimozione per riferimento_normativo -->
            <div class="mb-3">
              <label for="RiferimentoNormativo" class="form-label">Riferimento Normativo</label><br>
              <div v-for="(riferimento, index) in model.fam_admin.itemFamiglia.riferimento_normativo" :key="'rifnorm_'+index"
                   class="input-group mb-1">
                <input type="text" class="form-control" placeholder="Inserisci Riferimento Normativo"
                       v-model="model.fam_admin.itemFamiglia.riferimento_normativo[index]">
                <button type="button" class="btn btn-danger" @click="removeRiferimentoNormativo(index)">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addRiferimentoNormativo"
                      v-if="model.fam_admin.itemFamiglia.riferimento_normativo[model.fam_admin.itemFamiglia.riferimento_normativo.length-1] != ''">Aggiungi Riferimento Normativo</button>
            </div>

            <!-- Modifica, Aggiunta e Rimozione per motivi_addebito_separazione -->
            <div class="mb-3">
              <label for="MotiviAddebitoSeparazione" class="form-label">Motivi Addebito Separazione</label><br>
              <div v-for="(motivo, index) in model.fam_admin.itemFamiglia.motivi_addebito_separazione" :key="'mas_'+index"
                   class="input-group mb-1">
                <select class="form-select" id="motivi_addebito_separazione" placeholder="Motivi Addebito"
                        v-model="model.fam_admin.itemFamiglia.motivi_addebito_separazione[index]">
                  <option value="">Scegli...</option>
                  <option v-for="(item, index) in Model.lista_motivi_addebito_separazione" :value="item" :key="'mads_'+item">{{ item }}</option>
                </select>
                <button type="button" class="btn btn-danger" @click="removeMotiviAddebitoSeparazione(index)"
                        v-if="model.fam_admin.itemFamiglia.motivi_addebito_separazione[model.fam_admin.itemFamiglia.motivi_addebito_separazione.length-1] != ''">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addMotiviAddebitoSeparazione">Aggiungi Motivi Addebito Separazione</button>
            </div>
            <div class="mb-3">
              <label for="iregime_mantenimento" class="form-label">Regime Mantenimento</label>
              <select class="form-select" id="iregime_mantenimento" v-model="model.fam_admin.itemFamiglia.regime_mantenimento">
                <option value="">Scegli...</option>
                <option v-for="(item, index) in Model.lista_regime_mantenimento" :value="item" :key="'regmant_'+item">{{ item }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="iregime_affidamento" class="form-label">Regime Affidamento</label>
              <select class="form-select" id="iregime_affidamento" v-model="model.fam_admin.itemFamiglia.regime_affidamento">
                <option value="">Scegli...</option>
                <option v-for="(item, index) in Model.lista_regime_affidamento" :value="item" :key="'regaff_'+item">{{ item }}</option>
              </select>
            </div>
            <div class="mb-3">
              <label for="iassegnazione_casa_familiare" class="form-label">Assegnazione casa familiare</label>
              <select class="form-select" id="iassegnazione_casa_familiare" v-model="model.fam_admin.itemFamiglia.assegnazione_casa_familiare">
                <option value="">Scegli...</option>
                <option v-for="(item, index) in Model.lista_assegnazione_casa_familiare" :value="item" :key="'asscasfam_'+item">{{ item }}</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="iregime_collocamento" class="form-label">Regime Collocamento</label>
              <select class="form-select" id="iregime_collocamento" v-model="model.fam_admin.itemFamiglia.regime_collocamento">
                <option value="">Scegli...</option>
                <option v-for="(item) in Model.lista_regime_collocamento" :value="item" :key="'regcoll_'+item">{{ item }}</option>
              </select>
            </div>

            <div class="mb-3">
              <label for="ivalore_assegno_mantenimento" class="form-label">Valore Assegno Mantenimento</label>
              <small>(Nota: Per rimuovere il valore inserire -1)</small>
              <input type="number" class="form-control" id="ivalore_assegno_mantenimento"
                     v-model.number="model.fam_admin.itemFamiglia.valore_assegno_mantenimento" step="0.01">
            </div>
            <div class="mb-3">
              <label for="ivalore_assegno_contributo_mantenimento" class="form-label">Valore Assegno Contributo Mantenimento</label>
              <small>(Nota: Per rimuovere il valore inserire -1)</small>
              <input type="number" class="form-control" id="ivalore_assegno_contributo_mantenimento"
                     v-model.number="model.fam_admin.itemFamiglia.valore_assegno_contributo_mantenimento" step="0.01">
            </div>
            <div class="mb-3">
              <label for="ivalore_assegno_divorzile" class="form-label">Valore Assegno Divorzile</label>
              <small>(Nota: Per rimuovere il valore inserire -1)</small>
              <input type="number" class="form-control" id="ivalore_assegno_divorzile"
                     v-model.number="model.fam_admin.itemFamiglia.valore_assegno_divorzile" step="0.01">
            </div>


            <div class="mb-3 not-visible">
              <label for="data" class="form-label">Data</label>
              <input type="date" class="form-control" id="data" v-model="model.fam_admin.itemFamiglia.data">
            </div>

            <div class="mb-3">
              <label for="idLocalita" class="form-label">Località</label>
              <select class="form-select" id="idLocalita" v-model="model.fam_admin.itemFamiglia.id_localita">
                <option value="">Scegli...</option>
                <option v-for="(item) in model.fam_lista_citta" :value="item.id_localita" :key="'citta_'+item.id_localita">{{ item.citta }}</option>
              </select>

            </div>
            <div class="mb-3">
              <label for="durataDelProcesso" class="form-label">Durata Procedimento</label>
              <small>(Nota: Per rimuovere il valore inserire -1)</small>
              <input type="number" class="form-control" id="durataDelProcesso" min="0"
                     v-model.number="model.fam_admin.itemFamiglia.durata_procedimento">
            </div>

            <!-- Modifica, Aggiunta e Rimozione per giudice -->
            <div class="mb-3">
              <label for="giudice" class="form-label">Giudice</label><br>
              <div v-for="(giudice, index) in model.fam_admin.itemFamiglia.giudice" :key="index" class="input-group mb-1">
                <input type="text" class="form-control" v-model="model.fam_admin.itemFamiglia.giudice[index]" placeholder="Inserisci giudice">
                <button type="button" class="btn btn-danger" @click="removeGiudice(index)">Rimuovi</button>
              </div>
              <button type="button" class="btn btn-primary btn-sm" @click="addGiudice"
                      v-if="model.fam_admin.itemFamiglia.giudice[model.fam_admin.itemFamiglia.giudice.length-1] != ''">Aggiungi Giudice</button>
            </div>

            <div class="mb-3 not-visible">
              <label for="dataElaborazione" class="form-label">Data Elaborazione</label>
              <input type="date" class="form-control" id="dataElaborazione"
                     v-model="model.fam_admin.itemFamiglia.data_elaborazione">
            </div>

          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-primary" @click="handleSubmit()" :disabled="comms.famigliaAdmin.inChiamataFamigliaSave">Salva</button>
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Chiudi</button>
          </div>
      </div>
    </div>
  </div>
</template>